import { AllFTUXes, isNull } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { PageID } from '../../../components/ReferenceBar/HelpDrawer/types.ts';
import { useFTUX } from '../../../controller/hooks/useFTUX.ts';
import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../../../redux/features/referenceBarUISlice.ts';
import { useAppDispatch } from '../../../redux/hooks.ts';

export function useAutoOpenHelpDrawer({ pageID }: { pageID: PageID | null }) {
  const dispatch = useAppDispatch();
  const { ftux, dismiss } = useFTUX(`autoHelpDrawer-${pageID}` as keyof AllFTUXes);

  useEffect(() => {
    if (isNull(pageID) || !ftux()) return;
    dispatch(setSelectedDataSheet('help-drawer'));
    dispatch(setReferenceViewOpen(true));
    dismiss(); // set count to greater than max, so we don't keep re-opening
  }, [pageID, dispatch, ftux, dismiss]);
}
